import { createSlice } from '@reduxjs/toolkit';
import { deleteAssets, submitAssets } from './Utils/TestimonyProgramUtils';

const initialState = {
  url: [],
  // isUpdate: false,
  id: '',
  isLoading: false,
};

const addAssets = createSlice(
  {
    name: 'addAssets',
    initialState: initialState,
    reducers: {
      setField: (state, action) => {
        const { field, value } = action.payload;
        state[field] = value;
      },
      resetState: (state) => {
        return initialState;
      },
    },
    extraReducers: (builder) => {
      builder
        .addCase(submitAssets.pending, (state) => {
          // Handle loading state
          state.isLoading = true;
        })
        .addCase(submitAssets.fulfilled, (state, action) => {
          // Handle success state
          state.isLoading = false;
          console.log('Sukses:', action.payload);
        })
        .addCase(submitAssets.rejected, (state, action) => {
          // Handle error state
          state.isLoading = false;
          console.log(action.error.message, "error action")
        })
        .addCase(deleteAssets.pending, (state) => {
          // Handle loading state
          state.isLoading = true;
        })
        .addCase(deleteAssets.fulfilled, (state, action) => {
          // Handle success state
          state.isLoading = false;
          console.log('Sukses:', action.payload);
        })
        .addCase(deleteAssets.rejected, (state, action) => {
          // Handle error state
          state.isLoading = false;
          console.log(action.error.message, "error action")
        });
    }
  }
);


export const { setField, resetState } = addAssets.actions;

export default addAssets.reducer;